// Returns a new descriptors array where any measure descriptor whose display
// name (`wd`) collides with another measure descriptor in the same language
// has its `data_source_acronym` suffixed in brackets, e.g. "Budgetary &
// Financial Management (AfDB)". Mirrors the build-time disambiguation
// applied to Nunjucks templates so static and runtime UIs stay in sync.
//
// The acronym is sourced from the measure object itself (populated from
// metadata column I and exposed by the `/svc/most/` endpoint). Measures
// without an acronym remain bare even when their names collide — fix the
// underlying data rather than guessing here.
export default function disambiguateDescriptors(descriptors, measures) {
  if (!Array.isArray(descriptors) || !Array.isArray(measures)) return descriptors;

  const acronymBySId = new Map();
  for (const m of measures) {
    if (m && typeof m.s_id === 'string') {
      acronymBySId.set(m.s_id, m.data_source_acronym || '');
    }
  }

  const result = descriptors.slice();

  const indicesByLang = new Map();
  for (let i = 0; i < result.length; i++) {
    const d = result[i];
    if (!d || typeof d.uid !== 'string' || d.uid[0] !== 'm') continue;
    const sId = d.uid.slice(1);
    if (!acronymBySId.has(sId)) continue;
    const list = indicesByLang.get(d.lang) || [];
    list.push({ idx: i, wd: d.wd, sId });
    indicesByLang.set(d.lang, list);
  }

  for (const [, items] of indicesByLang) {
    const counts = new Map();
    for (const it of items) counts.set(it.wd, (counts.get(it.wd) || 0) + 1);
    for (const it of items) {
      if ((counts.get(it.wd) || 0) < 2) continue;
      const acronym = acronymBySId.get(it.sId);
      if (!acronym) continue;
      const current = result[it.idx];
      result[it.idx] = { ...current, wd: `${current.wd} (${acronym})` };
    }
  }

  return result;
}
